import Component from '../../../scripts/utilities/component';

/**
 * LoadOptaWidget - used the manually load the opta widgets
 */
class LoadOptaWidget extends Component {
    componentDidMount() {
        this.win = window;
        this.widgets = [...this.mount.querySelectorAll('.eng-ms-opta-widget')];
        this.root.addEventListener('click', () => {
            this.loadWidget();
        });

        // if the tab is active on initial load, then start the opta widgets
        if (this.win.location.hash === this.root.hash || this.root.classList.contains('is--active')) {
            this.loadWidget();
        }
    }

    loadWidget() {
        // if opta settings have been defined and the opta script is loaded, 'start' the widgets
        if (this.widgets.length && this.win.opta_settings && this.win.Opta) {
            /*
                remove the load attribute from the widgets
                (when set to false this stops widgets from loading)
            */
            this.widgets.map((widget) => {
                const optaWidgetElement = widget.querySelector('opta-widget');

                // check if the opta markup hasn't been compiled to html and it's 'visible'
                if (optaWidgetElement && widget.offsetWidth > 0) {
                    optaWidgetElement.removeAttribute('load');
                }

                return widget;
            });

            this.win.Opta.start();
        } else {
            console.warn('Opta settings or opta widgets script not present');
        }
    }
}

export default LoadOptaWidget;



// WEBPACK FOOTER //
// ./components/eng-ms-load-opta-widget/scripts/load-opta-widget.js